import React from 'react';
import autobind from 'autobind-decorator';
import {Form} from "react-bootstrap";

import {service as SurveyAnswerPlantQuantityStockTypeService} from "../../../Services/SurveyAnswerPlantQuantityStockTypeService";
import {BaseFieldEditor} from "../../../Models/Core/FieldEditors/BaseFieldEditor";
import {BaseFieldViewer} from "../../../Models/Core/FieldViewers/BaseFieldViewer";

export { SpeciesFieldEditor } from './SpeciesFieldEditor'
export { SpeciesFieldViewer } from './SpeciesFieldViewer'

export class SurveyAnswerPlantQuantityStockTypeFieldEditor extends BaseFieldEditor {
    constructor(props) {
        super(props)

        this.setInitialState({
            surveyAnswerPlantQuantityStockTypes: []
        });
    }

    componentDidMount() {
        SurveyAnswerPlantQuantityStockTypeService.Get()
            .then((x) => {
                this.setState({ surveyAnswerPlantQuantityStockTypes: x.result});
            });
    }

    @autobind
    _render() {
        return <Form.Control
            as="select"
            placeholder="Select A Stock Type"
            value={this.props.Value != null ? this.props.Value : ""}
            onChange={(x) => this.props.OnUpdate(x.target.value)}
        >
            <option value="">Select A Stock Type</option>
            {
                this.state.surveyAnswerPlantQuantityStockTypes.map((x) => {
                    return <option key={x.surveyAnswerPlantQuantityStockTypeId} value={x.surveyAnswerPlantQuantityStockTypeId}>{x.name}</option>;
                })
            }
        </Form.Control>;
    }
}

export class SurveyAnswerPlantQuantityStockTypeFieldViewer extends BaseFieldViewer {
    constructor() {
        super();

        this.setInitialState({
            surveyAnswerPlantQuantityStockTypes: []
        });
    }

    @autobind
    shouldReloadData(prevProps, prevState) {
        return this.props.Value != prevProps.Value;
    }

    @autobind
    loadData() {
        super.loadData();

        SurveyAnswerPlantQuantityStockTypeService.Get()
            .then((x) => {
                this.setState({ surveyAnswerPlantQuantityStockTypes: x.result});
            });
    }

    @autobind
    getSurveyAnswerPlantQuantityStockTypes() {
        return this.state.surveyAnswerPlantQuantityStockTypes.find((x) => x.surveyAnswerPlantQuantityStockTypeId == this.props.Value);
    }

    @autobind
    _render() {
        let modelJSON = this.getSurveyAnswerPlantQuantityStockTypes();
        return <span>{modelJSON ? modelJSON.name : "N/A"}</span>;
    }

}